"use client";

import { useState } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { makeQueryClient } from "./lib/react-query/query-client";

/**
 * Клиентская оболочка для TanStack Query.
 * Корневой layout остаётся Server Component — он только импортирует этот модуль и оборачивает children.
 */
export function ReactQueryProvider({ children }) {
  const [queryClient] = useState(() => makeQueryClient());

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
